import {
  SYSTEM_GET_ALL_EDU_BEGIN,
  SYSTEM_GET_ALL_EDU_SUCCESS,
  SYSTEM_GET_ALL_EDU_FAILURE,
  SYSTEM_GET_ALL_EDU_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getAllEdu(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: SYSTEM_GET_ALL_EDU_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
        request({
          method:'post',
          url:'/api/b/edu/list',
        }).then( data => {
            dispatch({
                type: SYSTEM_GET_ALL_EDU_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: SYSTEM_GET_ALL_EDU_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetAllEduError() {
  return {
    type: SYSTEM_GET_ALL_EDU_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SYSTEM_GET_ALL_EDU_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getAllEduPending: true,
        getAllEduError: null,
      };

    case SYSTEM_GET_ALL_EDU_SUCCESS:
      // The request is success
      const byId = {};
      const items = [];
      action.data.list.forEach(item => {
        items.push(item.id);
        byId[item.id] = item;
      });
      return {
        ...state,
        allEduById:byId,
        allEduList:items,
        getAllEduPending: false,
        getAllEduError: null,
      };

    case SYSTEM_GET_ALL_EDU_FAILURE:
      // The request is failed
      return {
        ...state,
        getAllEduPending: false,
        getAllEduError: action.data.error,
      };

    case SYSTEM_GET_ALL_EDU_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getAllEduError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/system/redux/getAllEdu.js